import { clx, Icon, icon } from "@hm/fundamental"

interface MultiselectTriggerProps {
	triggerRef: React.Ref<HTMLButtonElement>
	label: string
	triggerLabel: string
	isOpen: boolean
	disabled: boolean
	listboxId: string
	hasSelection: boolean
	onToggle: () => void
	onKeyDown: (event: React.KeyboardEvent) => void
	"data-cy": string
}

export const MultiselectTrigger: React.FC<MultiselectTriggerProps> = ({
	triggerRef,
	label,
	triggerLabel,
	isOpen,
	disabled,
	listboxId,
	hasSelection,
	onToggle,
	onKeyDown,
	"data-cy": dataCy,
}) => {
	return (
		<button
			ref={triggerRef}
			type="button"
			onClick={onToggle}
			onKeyDown={onKeyDown}
			disabled={disabled}
			aria-expanded={isOpen}
			aria-haspopup="listbox"
			aria-controls={isOpen ? listboxId : undefined}
			className={clx(
				"flex items-center justify-between w-full h-12 gap-2 rounded-lg border border-solid px-3 text-left",
				"border-border bg-container_background text-foreground",
				isOpen && "border-primary",
				disabled && "opacity-50 cursor-not-allowed",
			)}
			data-cy={`${dataCy}-trigger`}
		>
			<div className="flex flex-col justify-center min-w-0 flex-1">
				{hasSelection ? (
					<>
						<span className="text-xs font-normal leading-4 text-foreground_faded">
							{label}
						</span>
						<span className="text-[1rem] font-medium truncate">
							{triggerLabel}
						</span>
					</>
				) : (
					<span className="text-base font-medium leading-6 text-foreground_faded">
						{triggerLabel}
					</span>
				)}
			</div>
			<Icon path={icon.mdiChevronDown} className="shrink-0 w-5 h-5" />
		</button>
	)
}
